import { render } from "./WorkloadApprovalDialog.vue?vue&type=template&id=32dc08d5"
import script from "./WorkloadApprovalDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadApprovalDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__